
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { Trash2, Edit2, Save, X } from 'lucide-react';

const API_BASE = 'https://api.lionsmd320.org/admin/api/api';

export default function ResponsesCrudModule({ formIdProp }) {
  const navigate = useNavigate();
  const { formId: routeFormId } = useParams() || {};
  const formId = formIdProp || routeFormId; // Takes formId directly from URL route

  const [responses, setResponses] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editRowData, setEditRowData] = useState({});

  const fetchResponses = async () => {
    try {
      const res = await axios.get(`${API_BASE}/responses/${formId}`);
      if (res.data.success) setResponses(res.data.responses);
    } catch (err) {
      alert('Failed to load responses.');
    }
  };

  useEffect(() => {
    if (formId) fetchResponses();
  }, [formId]);



const handleDelete = async (id) => {
    if (!window.confirm('Delete entry permanently?')) return;
    try {
      await axios.delete(`${API_BASE}/responses/${id}`);
      fetchResponses();
    } catch (err) {
      alert('Failed to delete row.');
    }
  };

  const startEdit = (row) => {
    setEditingId(row.id);
    setEditRowData({ ...row });
  };

  const handleSaveEdit = async (id) => {
    try {
      await axios.put(`${API_BASE}/responses/${id}`, editRowData);
      setEditingId(null);
      fetchResponses();
    } catch (err) {
      alert('Failed to update row.');
    }
  };

  if (responses.length === 0) return (
    <div style={{ backgroundColor: '#090d16', color: '#fff', minHeight: '100vh', padding: '24px' }}>
      <button onClick={() => navigate(-1)} style={{ backgroundColor: '#1e293b', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', marginBottom: '16px' }}>← Back</button>
      <p>No response entries found for form ID: <code>{formId}</code></p>
    </div>
  );

  const columns = Object.keys(responses[0]);

  return (
    <div style={{ backgroundColor: '#090d16', color: '#e2e8f0', minHeight: '100vh', padding: '24px', fontFamily: 'sans-serif' }}>
      <button onClick={() => navigate(-1)} style={{ backgroundColor: '#1e293b', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', marginBottom: '16px' }}>← Back to Form Builder</button>

      <h2 style={{ fontSize: '18px', margin: '0 0 16px 0', color: '#f8fafc' }}>CRUD Manager for `{formId}`</h2>

      <div style={{ overflowX: 'auto', border: '1px solid #1e293b', borderRadius: '12px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '13px' }}>
          <thead style={{ backgroundColor: '#0f172a', color: '#94a3b8' }}>
            <tr>
              {columns.map(col => <th key={col} style={{ padding: '12px', borderBottom: '1px solid #1e293b' }}>{col}</th>)}
              <th style={{ padding: '12px', borderBottom: '1px solid #1e293b' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {responses.map((row) => (
              <tr key={row.id} style={{ borderBottom: '1px solid #1e293b' }}>
                {columns.map((col) => (
                  <td key={col} style={{ padding: '10px 12px' }}>
                    {editingId === row.id && col !== 'id' && col !== 'form_id' && col !== 'created_at' ? (
                      <input
                        type="text"
                        value={editRowData[col] || ''}
                        onChange={(e) => setEditRowData({ ...editRowData, [col]: e.target.value })}
                        style={{ backgroundColor: '#020617', border: '1px solid #334155', color: '#fff', padding: '4px 8px', borderRadius: '4px' }}
                      />
                    ) : (
                      String(row[col] || '')
                    )}
                  </td>
                ))}
                <td style={{ padding: '10px 12px', display: 'flex', gap: '8px' }}>
                  {editingId === row.id ? (
                    <>
                      <button onClick={() => handleSaveEdit(row.id)} style={{ backgroundColor: '#059669', color: '#fff', border: 'none', padding: '6px', borderRadius: '4px', cursor: 'pointer' }}><Save size={14} /></button>
                      <button onClick={() => setEditingId(null)} style={{ backgroundColor: '#475569', color: '#fff', border: 'none', padding: '6px', borderRadius: '4px', cursor: 'pointer' }}><X size={14} /></button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => startEdit(row)} style={{ backgroundColor: '#0284c7', color: '#fff', border: 'none', padding: '6px', borderRadius: '4px', cursor: 'pointer' }}><Edit2 size={14} /></button>
                      <button onClick={() => handleDelete(row.id)} style={{ backgroundColor: '#dc2626', color: '#fff', border: 'none', padding: '6px', borderRadius: '4px', cursor: 'pointer' }}><Trash2 size={14} /></button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}